let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3yMpG")).then(() => parcelRequire('6xJo7'));